const crudder = endpoint => path => {
  const url = `${endpoint}${path}`

  return ({
    create: (data) =>
      window.fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(res => res.json()),
    get: () =>
      window.fetch(url)
        .then(res => res.json())
  })
}

export default crudder
